import React, { FC } from 'react';
import { RocheUIStagingHero, RocheUIStagingHeroVariant, RocheUIImageRatio } from '@repo/roche-ui';
import { BlokToComponentProps } from '../../helpers/blok-to-component/types';

type SlottedImageDataType = {
  src?: {
    filename?: string;
    title?: string;
    copyright?: string;
    alt?: string;
  };
  brightcove_id?: string;
  _uid?: string;
};

type RocheStagingHeroProps = BlokToComponentProps<{
  slotted_image: SlottedImageDataType[];
  variant?: RocheUIStagingHeroVariant;
  headline?: string;
  content?: string;
  slot?: string;
}>;

export const RocheStagingHero: FC<RocheStagingHeroProps> = ({ blok, slot }) => {
  const getImageOrVideoProps = () => {
    const imageElement = blok.slotted_image?.[0];

    if (!imageElement) {
      return null;
    }

    const brightcoveID = imageElement?.brightcove_id;
    if (typeof brightcoveID === 'string' && brightcoveID.trim() !== '') {
      return { 'brightcove-id': brightcoveID };
    }

    const imageSrc = imageElement?.src;
    if (imageSrc?.filename) {
      return {
        src: imageSrc.filename,
        caption: imageSrc.title,
        copyright: imageSrc.copyright,
        alt: imageSrc.alt,
      };
    }

    return null;
  };

  const imageVideoProps = getImageOrVideoProps();

  return (
    <RocheUIStagingHero
      slot={slot}
      variant={blok.variant as RocheUIStagingHeroVariant}
      headline={blok.headline}
      content={blok.content}
      Image={
        blok.variant === RocheUIStagingHeroVariant.VARIANT_B && imageVideoProps ? (
          <roche-image slot='image' bleed={true} ratio={RocheUIImageRatio.WIDE} {...imageVideoProps} />
        ) : undefined
      }
    />
  );
};
